// extracted by mini-css-extract-plugin
module.exports = {"Account":"styles_Account__1WfhF","Account-header":"styles_Account-header__1WOQf","Account-content":"styles_Account-content__2FTJR","Account-footer":"styles_Account-footer__gCmh0"};